export default __webpack_public_path__ + "static/media/RomeToVenice.01680df3.webp";